// Bumble Bee Kratom — Custom Theme JS
// Initialises Lucide icons after DOM ready and on Shopify section events.

(function () {
  'use strict';

  function bbInitIcons() {
    if (window.lucide) window.lucide.createIcons();
  }

  // First paint
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bbInitIcons);
  } else {
    bbInitIcons();
  }

  // Re-run when Shopify theme editor loads / reorders a section
  document.addEventListener('shopify:section:load',    bbInitIcons);
  document.addEventListener('shopify:section:reorder', bbInitIcons);
})();


// darwer cart code
